import { Asset, FolderContent } from '@/api/generatedApi';
import { getFileExtension } from '@physna/supported-files';

export const isAsset = (asset: unknown): asset is Asset => {
  if (!asset || typeof asset !== 'object') return false;
  return (asset as FolderContent).contentType && (asset as FolderContent).contentType !== 'folder';
};

export const getAssetName = (asset: Asset) => {
  const fileName = getAssetFileName(asset);
  if (!fileName) return '';
  return fileName.slice(0, -getFileExtension(fileName.toLowerCase()).length);
};

export const getAssetFileName = (asset: Pick<Asset, 'path'>) => {
  return asset.path.split('/').pop() || '';
};

export const getAssetFolderDirectory = (asset: Asset) => {
  return asset.path.split('/').slice(0, -1).join('/');
};

export const getAssetsFromFolderContents = (contents: FolderContent[]) => {
  return contents.filter(content => isAsset(content)) as Asset[];
};
